import { FooterDisclaimerItem, SanityRichTextBlock } from 'types/sanity';

/**
 * Flattens an array of FooterDisclaimerItem objects into a flat array of SanityRichTextBlock objects.
 *
 * For each disclaimer item:
 * - If `custom` exists, it uses that array
 * - If `shared.content` exists, it uses that array
 * - Otherwise, it skips the item
 *
 * @param footerDisclaimers - Array of FooterDisclaimerItem objects
 * @returns Flattened array of SanityRichTextBlock objects
 */
export function flattenSharedFooterDisclaimers(
	footerDisclaimers: Array<FooterDisclaimerItem>
): Array<SanityRichTextBlock> {
	return footerDisclaimers
		.filter((disclaimer) => disclaimer.custom || disclaimer.shared?.content)
		.flatMap((disclaimer) => disclaimer.custom ?? disclaimer?.shared?.content) as Array<SanityRichTextBlock>;
}
